export default "__VITE_ASSET__DzNw$569__"